module.exports = __webpack_public_path__ + "img/2025-03-12e_3.64f4deb0.jpg";